import { render, staticRenderFns } from "./ElectronicWallet.vue?vue&type=template&id=f38b4c66&scoped=true&"
import script from "./ElectronicWallet.vue?vue&type=script&lang=js&"
export * from "./ElectronicWallet.vue?vue&type=script&lang=js&"
import style0 from "./ElectronicWallet.vue?vue&type=style&index=0&id=f38b4c66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38b4c66",
  null
  
)

export default component.exports